import styled from 'styled-components';
import { css } from 'styled-components';
import { getThemeColor, legacyTheme } from 'styles/theme';
import { media } from 'styles/media';

export const StyledProductSize = styled.div`
  ${({ theme }) => css`
    background-color: ${legacyTheme.colors.primary};
    color: ${legacyTheme.colors.white};
    width: 4rem;
    height: 4rem;
    min-width: 4rem;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;

export const StyledProductColor = styled.div`
  ${({ color, theme }) => css`
    background-color: ${getThemeColor(color)};
    width: 4rem;
    height: 4rem;
    min-width: 4rem;
    border-radius: 50%;
    border: 1px solid ${legacyTheme.colors.cream};

    ${media.lessThan('md')`
      width: 2.4rem;
      height: 2.4rem;
      min-width: 2.4rem;
    `}
  `}
`;

export const StyledBulbChangeInstruction = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  column-gap: ${legacyTheme.spacing.s3};

  &:not(:last-child) {
    margin-bottom: ${legacyTheme.spacing.s3};

    ${media.lessThan('md')`
      margin-bottom: ${legacyTheme.spacing.s2};
    `}

    ${media.lessThan('sm')`
      margin-bottom: ${legacyTheme.spacing.s1};
    `}
  }

  ${media.lessThan('md')`
    column-gap: ${legacyTheme.spacing.s2};
  `}

  ${media.lessThan('sm')`
    column-gap: ${legacyTheme.spacing.s1};
  `}
`;
